import React, { useState, useEffect } from 'react';
import { loadData } from '../services/codeDataStore';
import LegalPageLayout from '../components/LegalPageLayout';

const Copyright = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCopyrightContent();
  }, []);

  const fetchCopyrightContent = async () => {
    try {
      const site = await loadData('site', {});
      
      if (site?.copyright || site?.privacyPolicy) {
        setContent(site.copyright || site.privacyPolicy);
      } else {
        setError('Copyright content not found.');
      }
    } catch (err) {
      setError('Failed to fetch copyright content.');
      console.error('Error fetching copyright content:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LegalPageLayout
      title="Copyright & Open Access Policy"
      subtitle="Open access licensing terms under CC BY 4.0, author copyright retention, and reproduction rights."
      content={content}
      loading={loading}
      error={error}
      activePolicy="copyright"
    />
  );
};

export default Copyright;